import { library } from '@fortawesome/fontawesome-svg-core';

import {
  FontAwesomeIcon,
  FontAwesomeLayers,
  FontAwesomeLayersText,
} from '@fortawesome/vue-fontawesome';

import {
  faStripe,
} from '@fortawesome/free-brands-svg-icons';

import {
  faBan as falBan,
  faTvRetro as falTvRetro,
  faArchive as falArchive,
  faAngleDown as falAngleDown,
  faBroadcastTower as falBroadcastTower,
  faCheckCircle as falCheckCircle,
  faCircleNotch as falCircleNotch,
  faClock as falClock,
  faCloudDownloadAlt as falCloudDownloadAlt,
  faDesktop as falDesktop,
  faDollarSign as falDollarSign,
  faEllipsisV as falEllipsisV,
  faExpandArrows as falExpandArrows,
  faEye as falEye,
  faFileCertificate as falFileCertificate,
  faFileInvoiceDollar as falFileInvoiceDollar,
  faFolder as falFolder,
  faFolderOpen as falFolderOpen,
  faFolders as falFolders,
  faGuitar as falGuitar,
  faHeart as falHeart,
  faInfoCircle as falInfoCircle,
  faPaintBrush as falPaintBrush,
  faPrint as falPrint,
  faShieldCheck as falShieldCheck,
  faSlash as falSlash,
  faTag as falTag,
  faTags as falTags,
  faTheaterMasks as falTheaterMasks,
  faThLarge as falThLarge,
  faThList as falThList,
  faTint as falTint,
  faTrashAlt as falTrashAlt,
  faUnlockAlt as falUnlockAlt,
} from '@fortawesome/pro-light-svg-icons';

import {
  faTvRetro as farTvRetro,
  faArchive as farArchive,
  faCartPlus as farCartPlus,
  faCashRegister as farCashRegister,
  faChevronDoubleDown as farChevronDoubleDown,
  faClipboard as farClipboard,
  faEdit as farEdit,
  faEllipsisV as farEllipsisV,
  faFileAlt as farFileAlt,
  faFileAudio as farFileAudio,
  faFileCertificate as farFileCertificate,
  faFileDownload as farFileDownload,
  faFileImage as farFileImage,
  faFilePdf as farFilePdf,
  faFileVideo as farFileVideo,
  faLink as farLink,
  faLock as farLock,
  faInfoCircle as farInfoCircle,
  faPaste as farPaste,
  faQuestionCircle as farQuestionCircle,
  faSeedling as farSeedling,
  faStar as farStar,
  faThumbtack as farThumbtack,
  faTimes as farTimes,
  faTools as farTools,
  faTrophy as farTrophy,
  faSnooze as farSnooze,
} from '@fortawesome/pro-regular-svg-icons';

import {
  faBan as fasBan,
  faArrowAltRight as fasArrowAltRight,
  faChevronUp as fasChevronUp,
  faCheckCircle as fasCheckCircle,
  faCoins as fasCoins,
  faFileImage as fasFileImage,
  faFilter as fasFilter,
  faFolder as fasFolder,
  faFolders as fasFolders,
  faFolderOpen as fasFolderOpen,
  faGlobeAsia as fasGlobeAsia,
  faLock as fasLock,
  faMinusCircle as fasMinusCircle,
  faPause as fasPause,
  faQuestion as fasQuestion,
  faSave as fasSave,
  faShare as fasShare,
  faShoppingCart as fasShoppingCart,
  faSquare as fasSquare,
  faSlash as fasSlash,
  faStar as fasStar,
  faStars as fasStars,
  faTag as fasTag,
  faTimesCircle as fasTimesCircle,
  faUserLock as fasUserLock,
  faVolumeUp as fasVolumeUp,
  faVolumeSlash as fasVolumeSlash,
  faThumbtack as fasThumbtack,
} from '@fortawesome/pro-solid-svg-icons';

import {
  faCheckCircle as fadCheckCircle,
  faCreditCard as fadCreditCard,
  faExclamationCircle as fadExclamationCircle,
  faFolders as fadFolders,
  faPlug as fadPlug,
  faStore as fadStore,
  faUniversity as fadUniversity,
  faVolumeSlash as fadVolumeSlash,
  faVrCardboard as fadVrCardboard,
  faWifiSlash as fadWifiSlash,
} from '@fortawesome/pro-duotone-svg-icons';

import {
  faMeUnlimited as falMeUnlimited,
  faMeGlobeAsia as falMeGlobeAsia,
  faMeAspectRatio as falMeAspectRatio,
  faMeFileConvert as falMeFileConvert,
  faMeFiles as falMeFiles,
  faMeFolderMove as falMeFolderMove,
  faMeFormat as falMeFormat,
  faMeFrameRate as falMeFrameRate,
  faMeFraming as falMeFraming,
  faMeLightning as falMeLightning,
  faMeMetronome as falMeMetronome,
  faMePolygon as falMePolygon,
  faMeProRectangle as falMeProRectangle,
  faMeProFreeRectangle as falMeProFreeRectangle,
  faMeResolution as falMeResolution,
  faMeVrMono as falMeVrMono,
  faMeUserArtist as falMeUserArtist,
} from '@motionelements/assets/src/js/me-font/icons/me-font-icons-light.js';

import {
  faMeAnimated as farMeAnimated,
  faMeCc14 as farMeCc14,
  faMeCc15 as farMeCc15,
  faMeCc17 as farMeCc17,
  faMeCc18 as farMeCc18,
  faMeCc19 as farMeCc19,
  faMeCc20 as farMeCc20,
  faMeCs3 as farMeCs3,
  faMeCs4 as farMeCs4,
  faMeCs5 as farMeCs5,
  faMeCs55 as farMeCs55,
  faMeCs6 as farMeCs6,
  faMeFileConvert as farMeFileConvert,
  faMeFormat as farMeFormat,
  faMePolygon as farMePolygon,
  faMeRigged as farMeRigged,
  faMeSearch as farMeSearch,
  faMeMtn3 as farMeMtn3,
  faMeMtn4 as farMeMtn4,
  faMeMtn5 as farMeMtn5,
  faMeMtn6 as farMeMtn6,
  faMeNonProRectangle as farMeNonProRectangle,
  faMeProRectangle as farMeProRectangle,
  faMeProFreeRectangle as farMeProFreeRectangle,
  faMeVertices as farMeVertices,
  faMeVrMono as farMeVrMono,
  faMeVrPhoto as farMeVrPhoto,
  faMeVrVideo as farMeVrVideo,
} from '@motionelements/assets/src/js/me-font/icons/me-font-icons-regular.js';

import {
  faMePlugin as fasMePlugin,
  faMeFcp as fasMeFcp,
  faMeAdobePremierePro as fasMeAdobePremierePro,
  faMeAdobePremiereRush as fasMeAdobePremiereRush,
  faMeGraphicTemplate as fasMeGraphicTemplate,
  faMeUiTemplate as fasMeUiTemplate,
  faMePresentationTemplate as fasMePresentationTemplate,
  faMeNotionTemplate as fasMeNotionTemplate,
  faMePrompt as fasMePrompt,
} from '@motionelements/assets/src/js/me-font/icons/me-font-icons-solid.js';

import {
  faMeCc14 as fadMeCc14,
  faMeCc15 as fadMeCc15,
  faMeCc17 as fadMeCc17,
  faMeCc18 as fadMeCc18,
  faMeCc19 as fadMeCc19,
  faMeCc20 as fadMeCc20,
  faMeCs3 as fadMeCs3,
  faMeCs4 as fadMeCs4,
  faMeCs5 as fadMeCs5,
  faMeCs55 as fadMeCs55,
  faMeCs6 as fadMeCs6,
  faMeDr15 as fadMeDr15,
  faMeDr16 as fadMeDr16,
  faMeDr17 as fadMeDr17,
  faMeDr18 as fadMeDr18,
  faMeMtn3 as fadMeMth3,
  faMeMtn4 as fadMeMth4,
  faMeMtn5 as fadMeMth5,
  faMeMtn6 as fadMeMth6,
} from '@motionelements/assets/src/js/me-font/icons/me-font-icons-duotone.js';

library.add(
  falAngleDown,
  falArchive,
  falBan,
  falBroadcastTower,
  falCheckCircle,
  falCircleNotch,
  falClock,
  falCloudDownloadAlt,
  falDesktop,
  falDollarSign,
  falEllipsisV,
  falExpandArrows,
  falEye,
  falFileCertificate,
  falFileInvoiceDollar,
  falFolder,
  falFolderOpen,
  falFolders,
  falGuitar,
  falHeart,
  falInfoCircle,
  falPaintBrush,
  falPrint,
  falShieldCheck,
  falSlash,
  falTag,
  falTags,
  falTheaterMasks,
  falThLarge,
  falThList,
  falTint,
  falTrashAlt,
  falTvRetro,
  falUnlockAlt,

  farArchive,
  farCartPlus,
  farCashRegister,
  farChevronDoubleDown,
  farClipboard,
  farEdit,
  farEllipsisV,
  farFileAlt,
  farFileAudio,
  farFileCertificate,
  farFileDownload,
  farFileImage,
  farFilePdf,
  farFileVideo,
  farInfoCircle,
  farLink,
  farLock,
  farPaste,
  farQuestionCircle,
  farSeedling,
  farSnooze,
  farStar,
  farThumbtack,
  farTimes,
  farTools,
  farTrophy,
  farTvRetro,

  fasArrowAltRight,
  fasBan,
  fasCheckCircle,
  fasChevronUp,
  fasCoins,
  fasFileImage,
  fasFilter,
  fasFolder,
  fasFolderOpen,
  fasFolders,
  fasGlobeAsia,
  fasLock,
  fasMinusCircle,
  fasPause,
  fasQuestion,
  fasSave,
  fasShare,
  fasShoppingCart,
  fasSquare,
  fasSlash,
  fasStar,
  fasStars,
  fasTag,
  fasThumbtack,
  fasTimesCircle,
  fasUserLock,
  fasVolumeSlash,
  fasVolumeUp,

  fadCheckCircle,
  fadCreditCard,
  fadExclamationCircle,
  fadFolders,
  fadPlug,
  fadStore,
  fadUniversity,
  fadVolumeSlash,
  fadVrCardboard,
  fadWifiSlash,

  falMeAspectRatio,
  falMeFileConvert,
  falMeFiles,
  falMeFolderMove,
  falMeFormat,
  falMeFrameRate,
  falMeFraming,
  falMeGlobeAsia,
  falMeLightning,
  falMeMetronome,
  falMePolygon,
  falMeProFreeRectangle,
  falMeProRectangle,
  falMeResolution,
  falMeUnlimited,
  falMeUserArtist,
  falMeVrMono,

  farMeAnimated,
  farMeCc14,
  farMeCc15,
  farMeCc17,
  farMeCc18,
  farMeCc19,
  farMeCc20,
  farMeCs3,
  farMeCs4,
  farMeCs5,
  farMeCs55,
  farMeCs6,
  farMeFileConvert,
  farMeFormat,
  farMeMtn3,
  farMeMtn4,
  farMeMtn5,
  farMeMtn6,
  farMeNonProRectangle,
  farMePolygon,
  farMeProFreeRectangle,
  farMeProRectangle,
  farMeRigged,
  farMeSearch,
  farMeVertices,
  farMeVrMono,
  farMeVrPhoto,
  farMeVrVideo,

  fasMeAdobePremierePro,
  fasMeAdobePremiereRush,
  fasMeFcp,
  fasMePlugin,
  fasMeGraphicTemplate,
  fasMeUiTemplate,
  fasMePresentationTemplate,
  fasMeNotionTemplate,
  fasMePrompt,

  fadMeCc14,
  fadMeCc15,
  fadMeCc17,
  fadMeCc18,
  fadMeCc19,
  fadMeCc20,
  fadMeCs3,
  fadMeCs4,
  fadMeCs5,
  fadMeCs55,
  fadMeCs6,
  fadMeDr15,
  fadMeDr16,
  fadMeDr17,
  fadMeDr18,
  fadMeMth3,
  fadMeMth4,
  fadMeMth5,
  fadMeMth6,

  faStripe,
);


export default function install(Vue) {
  Vue.component('font-awesome-icon', FontAwesomeIcon);
  Vue.component('font-awesome-layers', FontAwesomeLayers);
  Vue.component('font-awesome-layers-text', FontAwesomeLayersText);
}
